import { useRef } from 'react';
import { useParams } from "react-router-dom";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { TopicRow } from "namirasoft-notification-sender";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSBox, NSBoxEntity, NSBoxString, NSBoxTextArea, NSButtonBlue, NSColumn, NSPanel, NSRow, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { NotificationSenderLayout } from "../NotificationSenderLayout";
import { NotificationSenderProps } from "../NotificationSenderProps";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { NotificationSenderRoutes } from "../NotificationSenderRoutes";

export interface SendPageProps extends NSARouterMakerResult, NotificationSenderProps { }

function SendPage(props: SendPageProps)
{
    let { id: topic_id } = useParams();

    let NSBoxEntity_Topic = useRef<NSBoxEntity<TopicRow>>(null);
    let NSBoxString_title = useRef<NSBoxString>(null);
    let NSBoxTextArea_Message = useRef<NSBoxTextArea>(null);

    let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

    const onSend = async (onFinished: () => void) =>
    {
        let topic_id: string;
        let title: string;
        let message: string;
        try
        {
            topic_id = NSBoxEntity_Topic.current?.getValueOne() ?? "";
            title = NSBoxString_title.current?.getValue(false) ?? "";
            message = NSBoxTextArea_Message.current?.getValue() ?? "";
        }
        catch (error)
        {
            // Input validation errors are not reported by the server, so notify here.
            props.notifier.onError(error as Error);
            onFinished();
            return;
        }

        try
        {
            const res = await props.servers.notification_sender.topic.Send({ topic_id, title, message });

            props.notifier.onSuccess("A message was sent successfully");

            let filters = [new FilterItem(
                namirasoft.notification_sender.tables.sent_topic,
                namirasoft.notification_sender.tables.sent_topic.columns.id,
                false,
                FilterItemOperator.all.equals,
                res.id
            )];

            props.url.redirect(NotificationSenderRoutes.SentTopicList, { filters: FilterItem.encode(filters) });
        }
        catch
        {
            // The server already reported the error through the notifier.
            onFinished();
        }
        onFinished();
    };

    return (
        <NotificationSenderLayout
            {...props}
            action={{
                title: "Send",
                description: "",
                menus: {}
            }}
        >
            <NSPanel style={{ margin: "0 auto" }}>
                <NSColumn style={{ width: NSBox.width.double }}>
                    <NSBoxEntity<TopicRow>
                        ref={NSBoxEntity_Topic}
                        title="Provider"
                        required
                        multiple={false}
                        table={namirasoft.notification_sender.tables.topic}
                        getValue={item => item.id}
                        getTitle={item => item.name}
                        getSort={() => null}
                        onLoaded={() => NSBoxEntity_Topic.current?.setValue(topic_id ?? null)}
                        style={{ width: "100%" }}
                    />
                    <NSBoxString
                        ref={NSBoxString_title}
                        title="Title"
                        required={false}
                        style={{ width: "100%" }}
                    />
                    <NSBoxTextArea
                        ref={NSBoxTextArea_Message}
                        title="Message"
                        required
                        placeholder="Write your Message"
                        style={{ width: "100%" }}
                    />

                    <NSSpace size={NSSpaceSizeType.MINI}></NSSpace>

                    <NSRow>
                        <NSButtonBlue
                            title="Apply"
                            onClick={{ action: onSend, showLoading: true }}
                        />
                    </NSRow>
                </NSColumn>
            </NSPanel>
        </NotificationSenderLayout>
    );
}

export default SendPage;